import AvatarMenu from "layouts/AvatarMenu";

export default function AdminAvatarMenu() {
  return (
    <AvatarMenu>
      {/*<MenuItem to="/setup/users" component={Link}>
        <ListItemIcon>
          <EngineeringIcon />
        </ListItemIcon>
        <ListItemText primary={I18n.t("Setup.title")} />
  </MenuItem>*/}
    </AvatarMenu>
  );
}
